//@ts-nocheck
import React from "react";
import { Typography, Grid, IconButton, Button, makeStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import StarIcon from "@material-ui/icons/Star";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    padding: 12,
    marginBottom: 16,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "rgba(12,12,13,0.1) 0px 16px 16px, rgba(12,12,13,0.05) 0px 4px 2px",
    width: "100%",
    boxSizing: "border-box",
  },
  iconBox: {
    width: 70,
    height: 70,
    flexShrink: 0,
    backgroundColor: "#f3f7f7",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  image: {
    width: 30,
    height: 30,
    objectFit: "contain",
    opacity: 0.7,
  },
  icon: {
    color: theme.palette.primary.main,
    opacity: 0.7,
  },
  nameGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    minWidth: 0,
    overflow: "hidden",
  },
  name: {
    fontSize: 19,
    fontWeight: 600,
    color: theme.palette.primary.main,
    lineHeight: 1,
    margin: 0,
  },
  description: {
    fontSize: 12,
    fontWeight: 400,
    color: "#666",
    lineHeight: 1.4,
    margin: 0,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priceRow: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
  },
  priceAmount: {
    fontSize: 19,
    fontWeight: 600,
    color: theme.palette.primary.main,
    lineHeight: 1,
  },
  perUnit: {
    fontSize: 14,
    fontWeight: 400,
    color: "#666",
    lineHeight: 1.4,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
}));

type PackageListRowProps = {
  image: string | React.ComponentType<{ size?: number; className?: string }>;
  name: string;
  description?: string;
  price: string;
  isRecommended?: boolean;
  cardClassName?: string;
  isDisabled?: boolean;
  onSelect?: () => void;
  onDetail?: () => void;
  classes?: Record<string, string>;
};

const PackageListRow = ({
  image,
  name,
  description,
  price,
  isRecommended,
  cardClassName,
  isDisabled,
  onSelect,
  onDetail,
  classes: classesProp,
}: PackageListRowProps) => {
  const ownClasses = useStyles();
  const classes = { ...ownClasses, ...classesProp };
  const IconComponent = typeof image !== "string" ? image : null;
  const imageSrc = typeof image === "string" ? image : undefined;

  return (
    <Grid item xs={12}>
      <div className={[classes.card, cardClassName].filter(Boolean).join(" ")}>
        <div className={classes.iconBox}>
          {IconComponent
            ? <IconComponent size={30} className={classes.icon} />
            : <img className={classes.image} src={imageSrc} alt={name} />}
        </div>
        <div className={classes.nameGroup}>
          <Typography className={classes.name}>{name}</Typography>
          <Typography className={classes.description}>{description}</Typography>
        </div>
        <div className={classes.priceRow}>
          <Typography className={classes.priceAmount}>{price}</Typography>
          <Typography className={classes.perUnit}>per unit</Typography>
        </div>
        {isRecommended && (
          <StarIcon style={{ color: "red", flexShrink: 0 }} />
        )}
        <div className={classes.actions}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={isDisabled}
            onClick={onSelect}
            style={{ width: 75, height: 34, fontSize: 12, borderRadius: 4 }}
            id="selectPackage"
          >
            Select
          </Button>
          <IconButton
            disableFocusRipple
            disableTouchRipple
            disableRipple
            id="dialogDetail"
            onClick={onDetail}
            aria-label="info"
          >
            <InfoOutlinedIcon style={{ color: "#54A4A6", width: "1.2em", height: "1.2em" }} />
          </IconButton>
        </div>
      </div>
    </Grid>
  );
};

export default PackageListRow;